/**
 * Created by Alex Aguilar on 7/27/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('airports', {
                parent: 'app',
                url: '/airports',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminAirport/airport/airports.html',
                        controller: 'airportsController',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('airports')
                            }],
                            'airports': ['airportService', '$stateParams', function (airportService, $stateParams) {
                                return airportService.getPageAirports($stateParams.page, $stateParams.size);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }]
                        }
                    }
                }
            })
            .state('airportNew', {
                parent: 'app',
                url: '/airport/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminAirport/airport/newAirport.html',
                        controller: 'newAirportController',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('airports')
                            }],
                            'countries': ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }]
                        }
                    }
                }
            })
            .state('airportEdit', {
                parent: 'app',
                url: '/airport/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/adminAirport/airport/editAirport.html',
                        controller: 'editAirportController',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function(tabService){
                                return tabService.getTabAdminAirports('airports')
                            }],
                            'countries': ['countryService', function(countryService){
                                return countryService.getActiveCountries(true,false);
                            }],
                            'airport': ['airportService', '$stateParams', function(airportService, $stateParams){
                                return airportService.getAirport($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }]
                        }
                    }
                }
            })
            .state('airportDelete', {
                parent: 'airports',
                url: '/airport/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/adminAirport/airport/deleteAirport.html',
                        controller: 'deleteAirportController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'airport': ['airportService', function(airportService) {
                                return airportService.getAirport($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['airport']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('airports', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
